<template>
  <v-container
    :class="
      isLoading || isThereAnError ? 'fill-height' : 'fill-height align-start'
    "
    style="background-color: #f8f8fd;"
    fluid
  >
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Fila si la venta está cargando -->
    <LoadingLayout v-if="isLoading">
      <LinearLoading>
        Cargando compra
      </LinearLoading>
    </LoadingLayout>
    <!-- Fila para mostrar el contenido -->
    <v-row v-else no-gutters>
      <!-- Columna en caso de error -->
      <v-col
        v-if="isThereAnError"
        class="custom-height"
        align="center"
        justify="center"
      >
        <v-row align="center" justify="center">
          <!-- Columna para la imagen -->
          <v-col cols="12" align="center" justify="center">
            <v-img
              class="hidden-md-and-up"
              src="https://deltia-production.s3.amazonaws.com/static/icons8-circled-x-100.png"
              max-width="20%"
            />
            <v-img
              class="hidden-sm-and-down"
              src="https://deltia-production.s3.amazonaws.com/static/icons8-circled-x-100.png"
              width="8%"
            />
          </v-col>
          <!-- Columna para el mensaje de error -->
          <v-col cols="12" align="center" justify="center">
            <p class="font-weight-medium red--text test--darken-2 pt-0 mt-0">
              {{ errorMessage }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- Columna para el contenido de la venta -->
      <v-col v-else cols="12">
        <!-- Título -->
        <v-row no-gutters>
          <!-- Nombre del producto -->
          <v-col cols="12" class="text-left">
            <p class="text-h6 font-weight-normal mt-0 pt-0 mb-3 pb-0">
              Resumen de la compra
            </p>
          </v-col>
        </v-row>
        <!-- Productos -->
        <v-divider></v-divider>
        <v-row v-for="product in sale.products" :key="product._id">
          <!-- Imagen del producto -->
          <v-col cols="3" md="1">
            <v-img
              class="DeltiaHitProductImage"
              aspect-ratio="1"
              :src="product.image_url"
              max-height="90px"
              max-width="100px"
            />
          </v-col>
          <!-- Información del producto -->
          <v-col cols="9" md="11">
            <!-- Nombre y precio -->
            <v-row class="mb-0 pb-0">
              <!-- Nombre del producto -->
              <v-col cols="7" class="text-left mb-0 pb-0">
                <p class="text-h6 font-weight-regular mb-0 pb-1">
                  {{ product.name }}
                </p>
              </v-col>
              <!-- Precio del producto -->
              <v-col cols="4" class="text-right mb-0 pb-0">
                <!-- Precio -->
                <p class="text-h6 font-weight-regular mb-0 pb-1">
                  ${{ product.amount }}
                </p>
              </v-col>
            </v-row>
            <!-- Precio unitario -->
            <v-row class="mb-0 pb-0">
              <!-- Nombre del producto -->
              <v-col cols="12" class="text-left mt-0 pt-0 mb-0 pb-0">
                <p v-if="product.discount" class="text--secondary mb-0 pb-1">
                  ${{ product.price_per_unit }}x{{ product.quantity }} - ${{
                    product.discount
                  }}
                </p>
                <p v-else class="text--secondary mb-0 pb-1">
                  ${{ product.price_per_unit }}x{{ product.quantity }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Monto agregado -->
        <p v-if="sale.additional_amount" class="text-h6 font-weight-regular">
          Monto adicional: ${{ sale.additional_amount }}
        </p>
        <v-divider></v-divider>
        <!-- Datos de pago (si la compra no se ha pagado) -->
        <v-container fluid class="pa-0" v-if="!sale.paid">
          <!-- Título de forma de pago -->
          <v-row no-gutters>
            <!-- Nombre del producto -->
            <v-col cols="12" class="text-left">
              <p class="text-h6 font-weight-light mt-3 pb-0 mb-3">
                Paga fácilmente por los productos de {{ sale.business_name }}
              </p>
            </v-col>
          </v-row>
          <!-- Pago -->
          <v-row>
            <!-- Tarjeta (Mercado Pago) -->
            <v-col cols="12">
              <form action="" method="post" id="form-pagar-mp">
                <!-- Datos del dueño de la tarjeta -->
                <v-row no-gutters>
                  <!-- Texto -->
                  <v-col cols="12">
                    <p class="mb-2 text--disabled font-weight-medium">
                      DATOS DEL TITULAR
                    </p>
                  </v-col>
                  <!-- Titular -->
                  <v-col cols="12" class="mb-3">
                    <input
                      id="holderName"
                      class="card-input"
                      placeholder="Titular de la tarjeta"
                      data-checkout="cardholderName"
                      type="text"
                    />
                  </v-col>
                  <!-- Email del titular -->
                  <v-col cols="12" class="mb-3">
                    <input
                      class="card-input"
                      placeholder="Email del titular"
                      data-checkout="cardholderEmail"
                      id="email"
                      name="email"
                      type="email"
                    />
                  </v-col>
                </v-row>
                <!-- Fila para el número de tarjeta y cvc -->
                <v-row no-gutters>
                  <!-- Texto -->
                  <v-col cols="12">
                    <p class="mb-2 text--disabled font-weight-medium">
                      DATOS DE LA TARJETA
                    </p>
                  </v-col>
                  <!-- Número de tarjeta -->
                  <v-col cols="9" class="mb-3 pr-1">
                    <input
                      data-checkout="cardNumber"
                      class="card-input"
                      id="cardNumber"
                      type="text"
                      placeholder="Número de tarjeta"
                    />
                  </v-col>
                  <!-- cvc -->
                  <v-col cols="3" class="pl-1">
                    <input
                      id="cvc"
                      class="card-input"
                      placeholder="CVC"
                      data-checkout="securityCode"
                      type="text"
                    />
                  </v-col>
                </v-row>
                <!-- Fila para el mes y el año -->
                <v-row no-gutters>
                  <!-- Mes -->
                  <v-col cols="6" class="pr-1">
                    <input
                      id="month"
                      class="card-input"
                      placeholder="MM"
                      data-checkout="cardExpirationMonth"
                      type="text"
                    />
                  </v-col>
                  <!-- Año -->
                  <v-col cols="6" class="pl-1">
                    <input
                      id="year"
                      class="card-input"
                      placeholder="AA"
                      data-checkout="cardExpirationYear"
                      type="text"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-col>
            <!-- Botón de pago -->
            <v-col cols="12">
              <v-btn
                :disabled="
                  !(
                    this.paymentFields.cardNumber &&
                    this.paymentFields.cardName &&
                    this.paymentFields.email &&
                    this.paymentFields.cvc &&
                    this.paymentFields.month &&
                    this.paymentFields.year
                  )
                "
                @click="pay"
                class="pay-with-stripe"
                :loading="isPaying"
                color="primary"
                depressed
              >
                Pagar ${{ sale.total }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <!-- Pantalla de éxito -->
        <v-container v-else>
          <v-row align="center" justify="center" no-gutters>
            <!-- Imagen de compra pagada -->
            <v-col cols="12" class="text-center">
              <p
                class="text-h6 font-weight-normal mt-0 pt-0 mb-3 pb-0 teal--text text--accent-3"
              >
                <v-icon class="d-inline" color="teal accent-3" x-large>
                  mdi-cart-check
                </v-icon>
                Compra pagada
              </p>
            </v-col>
            <!-- Texto de agradecimiento -->
            <v-col v-if="sale.thank_you_note" cols="12" class="text-center">
              {{ sale.thank_you_note }}
            </v-col>
            <!-- Nombre del negocio -->
            <v-col v-if="sale.thank_you_note" cols="12" class="text-right">
              - {{ sale.business_name }}
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Importar componentes
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import SnackbarMessage from "@/components/SnackbarMessage";

// Importar servicios
import MovementsServices from "@/services/MovementsServices";
import PaymentsServices from "@/services/PaymentsServices";

export default {
  name: "SharedSale",
  components: { LinearLoading, LoadingLayout, SnackbarMessage },
  data() {
    return {
      stripe: null,
      cardElement: null,
      cardError: null,
      isLoading: true,
      isThereAnError: false,
      isPayingWithOxxo: false,
      isPaying: false,
      complete: false,
      doSubmit: false,
      sale: {},
      payment: {
        paymentMethodId: ""
      },
      paymentFields: {
        cardNumber: false,
        cardName: false,
        email: false,
        cvc: false,
        month: false,
        year: false
      }
    };
  },
  mounted: async function() {
    try {
      // Obtener datos de la venta
      const { saleId } = this.$route.query;
      this.sale = await MovementsServices.getShareableSale(saleId);

      // Ocultar spinner
      this.isLoading = false;

      // Configurar stripe
      if (!this.sale.paid && this.sale.is_order) {
        setTimeout(this.setupMercadoPago, 0);
      }
    } catch (err) {
      // Ocultar spinner
      this.isLoading = false;

      // Mostrar error
      this.showError(err.message);
    }
  },
  methods: {
    showError: function(errorMessage) {
      this.isThereAnError = true;
      this.errorMessage = errorMessage;
    },
    pay: async function() {
      // Mostrar pantalla de carga
      this.isPaying = true;

      // Configurar payment method id
      this.getPaymentMethodId(() => {
        const $form = document.getElementById("form-pagar-mp");
        window.Mercadopago.createToken($form, this.mpResponseHandler);
      });
    },
    payWithOxxo: async function() {},
    setupMercadoPago: function() {
      // Configurar con la publishable key
      window.Mercadopago.setPublishableKey(this.sale.mp_access_token);

      document
        .getElementById("cardNumber")
        .addEventListener("input", this.handleCardInput);

      document
        .getElementById("holderName")
        .addEventListener("input", this.handleCardNameInput);

      document
        .getElementById("email")
        .addEventListener("input", this.handleEmailInput);

      document
        .getElementById("cvc")
        .addEventListener("input", this.handleCVCInput);

      document
        .getElementById("month")
        .addEventListener("input", this.handleMonthInput);

      document
        .getElementById("year")
        .addEventListener("input", this.handleYearInput);
    },
    onError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    },
    handleCardInput(event) {
      const cardnumber = document.getElementById("cardNumber").value;
      this.paymentFields.cardNumber = cardnumber.length >= 18;
      document.getElementById("cardNumber").value = cardnumber.substring(0, 19);
    },
    handleCardNameInput(event) {
      const cardName = document.getElementById("holderName").value;
      this.paymentFields.cardName = cardName.length >= 1;
    },
    handleEmailInput(event) {
      const email = document.getElementById("email").value;
      this.paymentFields.email = email.length >= 1;
    },
    handleCVCInput(event) {
      const cvc = document.getElementById("cvc").value;
      this.paymentFields.cvc = cvc.length >= 3;
      document.getElementById("cvc").value = cvc.substring(0, 4);
    },
    handleMonthInput(event) {
      const month = document.getElementById("month").value;
      this.paymentFields.month = month.length === 2;
      document.getElementById("month").value = month.substring(0, 2);
    },
    handleYearInput(event) {
      const year = document.getElementById("year").value;
      this.paymentFields.year = year.length === 2;
      document.getElementById("year").value = year.substring(0, 2);
    },
    getPaymentMethodId(responseHandler) {
      // Obtener datos de la tarjeta
      const cardnumber = document.getElementById("cardNumber").value;
      const bin = cardnumber.replace(/\s/g, "").substring(0, 6);

      // Configurar método de pago
      window.Mercadopago.getPaymentMethod({ bin }, (status, response) => {
        if (status == 200) {
          let paymentMethod = response[0];
          this.payment.paymentMethodId = paymentMethod.id;
          responseHandler();
        } else {
          // Ocultar pantalla de carga
          this.isPaying = false;

          this.onError(response);
        }
      });
    },
    mpResponseHandler: async function(status, response) {
      if (response.error) {
        this.isPaying = false;
        this.onError("Por favor revisa los datos de tu tarjeta");
      } else {
        try {
          const res = await PaymentsServices.payWithMp({
            saleId: this.$route.query.saleId,
            token: response.id,
            payment_method_id: this.payment.paymentMethodId,
            payer: document.getElementById("email").value
          });

          if (res.body.status === "approved") {
            this.sale.paid = true;

            // Enviar evento a mixpanel
            this.$mixpanel.track("order-paid");
          } else {
            switch (res.body.status_detail) {
              case "cc_rejected_insufficient_amount":
                throw new Error("Fondos insuficientes");
                break;
              case "cc_rejected_bad_filled_security_code":
                throw new Error("Código de seguridad inválido");
                break;
              case "cc_rejected_bad_filled_date":
                throw new Error("Error con la fecha de expiración");
              case "cc_rejected_bad_filled_other":
                throw new Error("Error con la información del formulario");
              default:
                throw new Error("Ocurrió un error al procesar la tarjeta");
                break;
            }
          }
        } catch (err) {
          // Ocultar pantalla de carga
          this.isPaying = false;
          window.Mercadopago.clearSession();

          this.onError(err.message);
        }
      }
    },
    onStripeError: function(error) {
      const errorMessages = {
        incorrect_number: "El número de tarjeta es incorrecto",
        invalid_number: "El número de la tarjeta no es válido",
        invalid_expiry_month: "El mes de expiración de la tarjeta no es válido",
        invalid_expiry_year: "El año de expiración de la tarjeta no es válido",
        invalid_cvc: "El código de seguridad de la tarjeta no es válido",
        expired_card: "La tarjeta ha expirado",
        incorrect_cvc: "El código de seguridad de la tarjeta es incorrecto",
        incorrect_zip:
          "Ocurrió un error al validar el código postal de la tarjeta",
        card_declined: "No se pudo verificar la tarjeta",
        missing: "No hay una tarjeta",
        processing_error: "Ocurrió un error al verificar la tarjeta"
      };

      // Verificar si se tiene una traducción para el error
      if (error.code in errorMessages) {
        this.onError(errorMessages[error.code]);
      } else {
        this.onError(error.message);
      }
    }
  }
};
</script>

<style scoped>
.DeltiaHitProductImage {
  border-radius: 8px;
}

.pay-with-stripe {
  width: 100%;
}

.card-input {
  background-color: white;
  -webkit-box-shadow: 10px 0px 20px 0px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 10px 0px 20px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 10px 0px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  width: 100%;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
  color: "#32325d";
}

.card-input:focus {
  outline: none;
}
</style>
